export default {
  confirmTransfer:
    '<strong>{0}</strong> üzerindeki istekleri diğer uygun araçlara aktarmak istediğinizi onaylayın. Ayrıca rotayı iptal etmeyi seçerseniz, çözülmemiş tüm istekler iptal edilecektir.',
  keepTheRoute: 'Rotayı Koruyun ve İstekleri Transfer Edin',
  cancelTheRoute: 'Rotayı İptal Edin ve İstekleri Transfer Edin',
  requestsTransferred: 'İstekler Transfer Edildi',
  requestTransferred: 'İstek Transfer Edildi',
  requestTransferredText: 'İstek başarıyla uygun araçlara transfer edildi.',
  requestsTransferredText: 'İstekler başarıyla uygun araçlara transfer edildi.',
  transferSummary: 'Transfer Özeti',
  unresolvedText:
    'Optimizasyon, <strong>{1}</strong> isteğin <strong>{0}</strong> tanesini diğer araçlara transfer edebildi. Aşağıdaki istekler trsanfer edilemedi. {2}',
  cancelUnresolved: 'Çözülmemiş İstekleri İptal Et',
  cancelRouteAlert: '<strong>{1}</strong> için <br/><strong>{0}</strong> iptal etmek istediğinizi onaylayın.',
  cancelRouteAlertWithOptions:
    'Rotadaki istekler için bir seçenek seçtikten sonra <br/><strong>{1}</strong> için <strong>{0}</strong> iptal etmek istediğinizi onaylayın.',
  tryTransfering: 'İstekleri diğer uygun araçlara transfer etmeyi deneyin ve çözülmemiş olanları iptal edin',
  cancelAllRequests: 'Tüm istekleri iptal et',
  routeCancelled: 'Rota İptal Edildi',
  routeCancelledText: 'Rota ve üzerindeki istekler iptal edildi.',
  routeNotCancelled: 'Rota İptal Edilmedi',
  routeKeptText:
    'İstekler seçiminize göre transfer edildi ya da iptal edildi, ancak bu sırada sürücü molaya başladığı ya da bir yolcu aldığı için rota hizmette kaldı. Mola ya da yolculuk bittiğinde rotayı iptal edebilirsiniz.',
  routeNotCancelledText: 'Rota iptal edilemedi. Yenilenen sayfada rotayı kontrol edin.',
  confirmAssignVehicle: '<strong>{1}</strong> yerine <strong>{0}</strong> aracını atamak istediğinizi onaylayın.',
  changeDriver: '<strong>{0}</strong> sürücüsünü <strong>{1}</strong> ile değiştirmek istediğinizden emin misiniz?',
  noOrderOrRequests: {
    title: 'İstekler transfer edilemez.',
    content: 'Hiçbir talep bulunamadı.',
  },
  confirmTransferSingleRequest:
    '<strong>{riderName}</strong> tarafından <strong>{date}</strong> tarihinde <strong>{pickupTime}</strong> saatinde alınmak üzere oluşturulmuş rezervasyonu <strong>{routeName}</strong> aracından başka uygun bir araca aktarmak istiyor musunuz?',
  requestNotBeAccommodated: 'Talep karşılanamadı.',
  checkingRequest: 'Talep için uygun araçları kontrol ediyoruz.',
  reactivateRouteAlert: '<strong> {0} </strong> rotasını aktive etmek istiyor musunuz?',
  deleteThisDayOnly: 'Sadece Bu Günü Sil',
  deleteAllDays: 'Tüm Günleri Sil',
  updateThisDayOnly: 'Sadece Bu Günü Güncelle',
  updateAllDays: 'Tüm Günleri Güncelle',
  transferSingle: 'Rezervasyonu Aktar',
  reservationDeleteConfirmation:
    'Bu rezervasyon {startDay} - {endDay} tarihleri arasında {days} günleri için geçerlidir. Sadece seçili gün için mi yoksa tüm günler için mi talebinizi iptal etmek istiyorsunuz?',
  driverBreakRequests: 'Sürücü Mola Talepleri',
  deleteDriverBreak:
    '<strong>{driverName}</strong> için <strong>{date}</strong> tarihinde <strong>{startTime}</strong> saatinde başlayan molayı silmek istiyor musunuz?',
  driverBreakNotFound: 'Mola bilgisi bulunamadı. Lütfen sayfayı yenileyip tekrar deneyin.',
  requestedPickupTime: 'Talep Edilen Biniş Saati',
  pickupStop: 'Biniş Durağı',
  dropoffStop: 'İniş Durağı',
  confirmation: 'Onay',
  offeredPickupTime: 'Teklif Edilen Biniş Saati',
  offeredDropoffTime: 'Teklif Edilen İniş Saati',
  driverPlannedActualDropoff: 'Sürücü Planlı / Gerçekleşen İniş Saati',
  plannedActualDropoffTime: 'Planlanan/Gerçekleşen İniş Saati',
  flexiRideSharedTracking: '{0} Takip',
  cancelRoute: 'Rotayı İptal Et',
  transferRequests: 'Talebi Aktar',
  activateRoute: 'Rotayı Aktif Et',
  multipleDrivers: 'Çoklu Sürücü',
  flexiRideSharedRequests: '{0} Talepleri',
  newFlexiRideSharedRequests: 'Yeni {0} Talebi',
  confirmPhone:
    '{0} profilinize kaydedilecek, böylece sürücüler gerektiğinde sizinle iletişime geçebilecek. Numaranızı doğrulamak için bir doğrulama kodu SMS ile gönderilecektir.',
  confirmNumber: 'Numarayı Onayla',
  verifyPhone: {
    verificationCodeTitle: 'Doğrulama Kodu ✉️',
    pleaseEnterCode: 'Lütfen telefon numarasına gönderilen doğrulama kodunu girin:',
    wrongNumber: 'Numarayı değiştir',
    verificationCode: 'Doğrulama kodu',
    wrongCode: 'Hatalı doğrulama kodu!',
  },
  noSafeRideRequest: 'Seçili dönem için {0} talebiniz bulunmamaktadır.',
  updateRequestWarning:
    'Talebin güncellenebilmesi için mevcut rezervasyon iptal edilerek yeni talep oluşturulacaktır. Yolcu talebinde değişiklik yapmak istiyor musunuz?',
  updateRequestWarningRider:
    'Talebinizin güncellenebilmesi için mevcut rezervasyonunuz iptal edilerek yeni talep oluşturulacaktır. Talebinizde değişiklik yapmak istiyor musunuz?',
  blacklistedByRider: '{riderNames} tarafından engellendi',
  driverBlacklistedSelectionBlocked:
    'Bu sürücü, {riderNames} için engellenen sürücüler listesinde olduğundan atanamaz.',
};
